import {Injectable} from '@angular/core';
import {AppConfig} from '../model/config';
import {HttpHelper} from './http.service';
import {AssignmentType} from '../model/assignmentType';
import {Schedule} from '../model/schedule';


@Injectable()
export class ScheduleService {


  constructor(
    private readonly httpClient: HttpHelper,
    private readonly configuration: AppConfig) {
  }

  async getAssignmentTypes() {

    let url: string = this.configuration.backendUrl + "/api/schedule/assignmenttypes";

    return await this.httpClient.get(url, () => {
      },
      () => {
      }).toPromise<AssignmentType[]>();
  }

  async getSchedules(dateKey: string) {

    let url: string = this.configuration.backendUrl + "/api/schedule/" + dateKey;

    return await this.httpClient.get(url, () => {
      },
      () => {
      }).toPromise<Schedule[]>();
  }

  async addSchedule(schedule: Schedule) {

    let url: string = this.configuration.backendUrl + "/api/schedule/create";

    return await this.httpClient.post(url, schedule, () => {
      },
      () => {
      }).toPromise<any>();
  }

  async updateSchedule(schedule: Schedule) {

    let url: string = this.configuration.backendUrl + "/api/schedule/update";

    return await this.httpClient.patch(url, schedule,
      () => {
      },
      () => {
      }).toPromise<any>();
  }

  async updateSchedulesList(schedules: Schedule[]) {
    let url: string = this.configuration.backendUrl + "/api/schedule/updateSchedulesList";

    return await this.httpClient.patch(url, schedules,
      () => {
      },
      () => {
      }).toPromise<any>();
  }

  async deleteSchedule(schedule: Schedule) {

    let url: string = this.configuration.backendUrl + "/api/schedule/delete/" + schedule.id;

    return await this.httpClient.delete(url,
      () => {
      },
      () => {
      }).toPromise<any>();
  }
}

